import axios from 'axios';

const recordConsent = (documents: string[]): Promise<void> => {
  return axios.post('/qualification/record_consent', {
    documentKeys: documents,
  });
};

export { recordConsent };
